mat-icon{position:absolute}
/*# sourceMappingURL=scrubber-cursor.component.css.map */
